/* istanbul ignore file */

export enum GridAggregation {
    PerRow = 1,
    PerSite = 2
}
